import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useContext,
} from "react";
import { getInvetoryItems } from "../../actions/DataActions";
import useGetAddress from "../walletsManagment/useGetAddress";
import ModalInventoryDetail from "../modal/ModalInventoryDetail";
import ItemInventory from "./ItemInventory";
import "./styles.css";
import { loader, notFound } from "../../assets";
import Footer from "../footer/Footer";
import { CHAIN } from "../../utils/constants/config";
import { AppContext } from "../walletsManagment/connectors";

const InventoryComponent = ({ chain }) => {
  const refSnapshotsSubscribers = useRef([]);
  const [state, setState] = useState({
    selectedFilter: "all",
    loading: false,
    inventories: null,
    isShowDetail: false,
    selectedInventory: null,
  });
  const account = useGetAddress(chain);
  const { cardanoWalletId } = useContext(AppContext);

  const onInventorySelection = useCallback((inventory) => {
    setState((state) => ({
      ...state,
      isShowDetail: true,
      selectedInventory: inventory,
    }));
  }, []);

  const handleFilterSelction = (e) => {
    switch (e.target.value) {
      case "all":
        setState((state) => ({ ...state, selectedFilter: "all" }));
        return;
      case "plots":
        setState((state) => ({ ...state, selectedFilter: "plots" }));
        return;
      case "condos":
        setState((state) => ({ ...state, selectedFilter: "condos" }));
        return;
      case "processing":
        setState((state) => ({ ...state, selectedFilter: "processing" }));
        return;

      default:
        return;
    }
  };

  const getInventoryData = async (filter) => {
    refSnapshotsSubscribers.current?.map((subscriber) => {
      subscriber();
    });

    setState((state) => ({ ...state, loading: true, inventories: [] }));
    refSnapshotsSubscribers.current = [];
    try {
      await getInvetoryItems(filter, account, chain, cardanoWalletId, {
        setInventory: (inventories) => {
          setState((state) => ({
            ...state,
            loading: false,
            inventories: inventories,
          }));
        },
        setSnapShotArray: (snapShots) => {
          refSnapshotsSubscribers.current = snapShots;
        },
      });

      setTimeout(() => {
        setState((state) => ({ ...state, loading: false }));
      }, 5000);
    } catch (ex) {
      setState((state) => ({ ...state, loading: false, inventories: null }));
    }
  };

  useEffect(() => {
    if (account) {
      getInventoryData(state.selectedFilter);
    } else {
      setState((state) => ({ ...state, loading: false, inventories: null }));
    }

    return () => {
      refSnapshotsSubscribers.current?.map((subscriber) => {
        subscriber();
      });
    };
  }, [state.selectedFilter, account]);
  return (
    <>
      <div className="inbox-inventory">
        <div className="container">
          <div className="inventory-section top-inventory">
            <h2 className="section-title">
              {chain == CHAIN.CARDANO
                ? "My Inventory (Monster Zone Only)"
                : "My Inventory"}
            </h2>
            <div className="filters">
              {account && (
                <div className="d-flex">
                  <button
                    className={`${
                      state.selectedFilter == "all"
                        ? "custom-btn light-bg lg active"
                        : "custom-btn light-bg lg"
                    }`}
                    onClick={handleFilterSelction}
                    value={"all"}
                  >
                    All
                  </button>
                  <button
                    className={`${
                      state.selectedFilter == "plots"
                        ? "custom-btn light-bg lg active"
                        : "custom-btn light-bg lg"
                    }`}
                    onClick={handleFilterSelction}
                    value={"plots"}
                  >
                    Plots
                  </button>
                  {chain === CHAIN.EITH && (
                    <button
                      className={`${
                        state.selectedFilter == "condos"
                          ? "custom-btn light-bg lg active"
                          : "custom-btn light-bg lg"
                      }`}
                      onClick={handleFilterSelction}
                      value={"condos"}
                    >
                      Condos
                    </button>
                  )}
                  <button
                    className={`${
                      state.selectedFilter == "processing"
                        ? "custom-btn light-bg lg active"
                        : "custom-btn light-bg lg"
                    }`}
                    onClick={handleFilterSelction}
                    value={"processing"}
                  >
                    Processing
                  </button>
                  {/* {state.loading && <Spinner size="lg" className=" mx-2 " />} */}
                </div>
              )}
            </div>
          </div>
          <div className="inventory-section">
            {!account && (
              <div className="notFound">
                <div className="imgHolder">
                  <img src={notFound} alt="not found" className="img" />
                </div>
                <p>Please login to view your inventories!</p>
              </div>
            )}

            {state.inventories?.length == 0 && account && !state.loading && (
              <div className="notFound">
                <div className="imgHolder">
                  <img src={notFound} alt="not found" className="img" />
                </div>
                <p>No inventory found!</p>
              </div>
            )}
            <div className="inventory">
              <div className="row">
                {state.inventories?.map((invetory) => (
                  <ItemInventory
                    inventory={invetory}
                    key={invetory.plot_id ?? invetory.id}
                    onItemSelection={onInventorySelection}
                  />
                ))}
              </div>
            </div>
          </div>

          <div
            className="loading-screen"
            style={{ display: state.loading ? "" : "none" }}
          >
            <div className="placeholder">
              <img src={loader} alt="loader" className="img" />
            </div>
          </div>

          <ModalInventoryDetail
            showDetail={state.isShowDetail}
            inventory={state.selectedInventory}
            closeModal={() => {
              setState((state) => ({ ...state, isShowDetail: false }));
            }}
          />
        </div>
      </div>

      <Footer />
    </>
  );
};

export default InventoryComponent;
